import { getGenAiBadges } from 'bundles/product-card/hooks/useGenAiBadges';

import _t from 'i18n!nls/product-card';

export const getProductCardStatusTags = (isNew?: boolean, isCostFree?: boolean, slug?: string) => {
  const { badges: genAiBadges } = getGenAiBadges(slug);
  const statusTags = [];

  if (isNew) {
    statusTags.push(_t('New'));
  }
  if (isCostFree) {
    statusTags.push(_t('Free'));
  }
  statusTags.push(...genAiBadges);

  return statusTags;
};
